export default __webpack_public_path__ + "static/media/free-templates.3da377da.gif";